import { SPORTS_PATH, SPORTS_SHOW_BOTTOM_NAV } from '../constants/sports'
import normalizePathname from './normalizePathname'

// Full-bleed routes: the embedded page owns the viewport, so no header / nav.
const CHROMELESS_PATHS = ['/register']

// `/casino/<platform>/<game>` — kept unanchored, as the inline check was.
const CHROMELESS_PATTERN = /\/casino\/.+\/.+/

// A parameter, not a direct read, so tests can drive both settings.
const isChromelessRoute = (
  pathname: string = window.location.pathname,
  showSportsBottomNav: boolean = SPORTS_SHOW_BOTTOM_NAV,
): boolean => {
  const normalized = normalizePathname(pathname)
  if (normalized === SPORTS_PATH) return !showSportsBottomNav
  return (
    CHROMELESS_PATHS.includes(normalized) || CHROMELESS_PATTERN.test(normalized)
  )
}

export default isChromelessRoute
